export function formatPhoneNumber(phoneNumber: string, countryCode: string) {
  if (!phoneNumber || Number(countryCode) !== Number(1)) return `${countryCode}+ ${phoneNumber}`;

  const firstPart = phoneNumber.substring(0, 3);
  const middlePart = phoneNumber.substring(3, 6);
  const lastPart = phoneNumber.substring(6, 10);

  return `+${countryCode} (${firstPart})-${middlePart}-${lastPart}`;
}
